import groupBy from 'lodash/groupBy';
import map from 'lodash/map';

import {
  WorkloadEventType,
  WorkloadOptimizationEvent,
  WorkloadOptimizationEventsSummary,
} from '@cast/types';

export const workloadEventsSummaryFor = (
  events: WorkloadOptimizationEvent[]
): WorkloadOptimizationEventsSummary => {
  const items = map(groupBy(events, 'type'), (items, key) => ({
    type: key as WorkloadEventType,
    count: items.length,
    percent: events.length ? 100 * (items.length / events.length) : 0,
  }));

  return { items, totalCount: events.length };
};
